<div [formGroup]="form" class="step-policy-info">

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Policy Name</mat-label>
    <input matInput formControlName="policyName" maxlength="100" placeholder="e.g. Standard VM Cleanup">
    <mat-hint align="end">{{ form.get('policyName')?.value?.length ?? 0 }}/100</mat-hint>
    <mat-error *ngIf="form.get('policyName')?.hasError('required')">
      Policy name is required.
    </mat-error>
    <mat-error *ngIf="form.get('policyName')?.hasError('pattern')">
      Only letters, digits, spaces, hyphens, and underscores. Must start with alphanumeric.
    </mat-error>
    <mat-error *ngIf="form.get('policyName')?.hasError('maxlength')">
      Maximum 100 characters.
    </mat-error>
    <mat-error *ngIf="form.get('policyName')?.hasError('nameTaken')">
      This policy name is already in use.
    </mat-error>
    <mat-spinner *ngIf="form.get('policyName')?.pending" matSuffix diameter="18" class="name-checking-spinner"></mat-spinner>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Description (optional)</mat-label>
    <textarea matInput formControlName="description" rows="3"
              maxlength="500" placeholder="Describe the intended use of this policy…"></textarea>
    <mat-hint align="end">{{ form.get('description')?.value?.length ?? 0 }}/500</mat-hint>
    <mat-error *ngIf="form.get('description')?.hasError('maxlength')">
      Maximum 500 characters.
    </mat-error>
  </mat-form-field>

</div>
